<template>
    <div>
        <!-- FASE 4 / BLOCO AB — DOC 11, 33, 40 -->
        <el-dialog :title="'Compartilhar — ' + (nomeAlvo || '')" :visible.sync="visivelLocal"
                   width="620px" @close="$emit('fechar')">

            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="12">
                    <el-select v-model="form.destino" style="width:100%" @change="form.ref_id = ''">
                        <el-option label="Usuário" value="usuario"></el-option>
                        <el-option label="Grupo de trabalho" value="grupo"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <el-select v-if="form.destino === 'usuario'" v-model="form.ref_id"
                               filterable remote :remote-method="buscar" :loading="buscando"
                               placeholder="Digite o nome" style="width:100%">
                        <el-option v-for="u in destinos.usuarios" :key="u.id"
                                   :label="u.name" :value="u.id"></el-option>
                    </el-select>
                    <el-select v-else v-model="form.ref_id" filterable placeholder="Escolha o grupo"
                               style="width:100%">
                        <el-option v-for="g in destinos.grupos" :key="g.id"
                                   :label="g.caminho" :value="g.id"></el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-row :gutter="10" class="u-mb-15">
                <el-col :xs="24" :sm="12">
                    <!-- DOC 11 — "leitor ou editor" -->
                    <el-radio-group v-model="form.papel">
                        <el-radio label="leitor">Leitor</el-radio>
                        <el-radio label="editor">Editor</el-radio>
                    </el-radio-group>
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button type="primary" size="small" icon="el-icon-share"
                               @click="compartilhar">COMPARTILHAR</el-button>
                </el-col>
            </el-row>

            <el-divider content-position="left">Quem tem acesso</el-divider>

            <table class="table table-striped">
                <thead>
                    <tr><th>Com quem</th><th style="width:110px">Papel</th>
                        <th style="width:130px">Detalhe</th><th style="width:60px"></th></tr>
                </thead>
                <tbody>
                    <tr v-for="c in lista" :key="c.id">
                        <td>
                            <i :class="iconeDestino(c.destino)"></i> {{ c.nome }}
                        </td>
                        <td><el-tag size="mini" :type="c.papel === 'editor' ? 'warning' : 'info'">{{ c.papel }}</el-tag></td>
                        <td class="meta">
                            <span v-if="c.destino === 'link'">
                                {{ c.acessos }} acesso(s)<br>
                                expira {{ c.expira_em | formatarData }}
                            </span>
                            <span v-else>—</span>
                        </td>
                        <td class="u-text-center">
                            <el-button type="danger" icon="el-icon-delete" size="mini" plain
                                       @click="revogar(c)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!lista.length">
                        <td colspan="4" class="u-text-center">Ainda não compartilhado.</td>
                    </tr>
                </tbody>
            </table>

            <el-divider content-position="left">Link externo (DOC 33)</el-divider>

            <el-row :gutter="10">
                <el-col :xs="24" :sm="10">
                    <el-input-number v-model="diasLink" :min="1" :max="365" size="small"></el-input-number>
                    <span class="meta"> dias de validade</span>
                </el-col>
                <el-col :xs="24" :sm="14" class="u-text-right">
                    <el-button size="small" icon="el-icon-link" @click="gerarLink">GERAR LINK</el-button>
                </el-col>
            </el-row>

            <div v-if="linkGerado" class="link-gerado u-mt-10">
                <el-input :value="linkGerado" readonly>
                    <el-button slot="append" icon="el-icon-document-copy" @click="copiar"></el-button>
                </el-input>
                <div class="meta">Guarde este link: ele não é exibido de novo.</div>
            </div>

            <!-- DOC 40 -->
            <template v-if="tipo === 'documento'">
                <el-divider content-position="left">Visibilidade (DOC 40)</el-divider>
                <el-switch v-model="publicoLocal" active-text="Público" inactive-text="Privado"
                           @change="definirVisibilidade"></el-switch>
                <div class="meta">
                    Público significa que qualquer pessoa com acesso ao sistema, dentro da
                    instituição, pode visualizar o documento.
                </div>
            </template>

            <span slot="footer">
                <el-button @click="$emit('fechar')">FECHAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>

import moment from 'moment'

export default {
    props: ['visivel', 'tipo', 'alvoId', 'nomeAlvo', 'publico'],
    filters: {
        formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '—' }
    },
    data: () => ({
        lista: [],
        destinos: { usuarios: [], grupos: [] },
        form: { destino: 'usuario', ref_id: '', papel: 'leitor' },
        buscando: false,
        diasLink: 30,
        linkGerado: null,
        publicoLocal: false
    }),
    computed: {
        visivelLocal: {
            get () { return this.visivel },
            set (v) { if (!v) this.$emit('fechar') }
        }
    },
    watch: {
        visivel (v) { if (v) { this.carregar(); this.publicoLocal = !!this.publico; this.linkGerado = null } }
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        iconeDestino (d) {
            if (d === 'grupo') return 'el-icon-s-custom'
            if (d === 'link')  return 'el-icon-link'
            return 'el-icon-user'
        },

        carregar () {
            this.$axios.post(`${this.base()}/api/documento-compartilhamento/listar/${this.tipo}/${this.alvoId}`,
                {}, this.auth()).then(r => { this.lista = r.data }).catch(e => { this.erro(e) })

            this.$axios.post(`${this.base()}/api/documento-compartilhamento/destinos/${this.tipo}/${this.alvoId}`,
                {}, this.auth()).then(r => { this.destinos = r.data }).catch(() => {})
        },

        buscar (termo) {
            if (!termo || termo.length < 2) return
            this.buscando = true
            this.$axios.post(`${this.base()}/api/documento-compartilhamento/destinos/${this.tipo}/${this.alvoId}`,
                { termo: termo }, this.auth()).then(r => {
                this.destinos = r.data
                this.buscando = false
            }).catch(e => { this.buscando = false; this.erro(e) })
        },

        compartilhar () {
            if (!this.form.ref_id) {
                window.eventBus.$emit('alert', { msg: 'Escolha com quem compartilhar.', type: 'warning' })
                return
            }

            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-compartilhamento/conceder/${this.tipo}/${this.alvoId}`,
                this.form, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Compartilhado.', type: 'success' })
                this.form.ref_id = ''
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        revogar (c) {
            this.$msgbox.confirm('Revogar este compartilhamento?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/documento-compartilhamento/revogar/${c.id}`, this.auth())
                    .then(() => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Acesso revogado.', type: 'success' })
                        this.carregar()
                    }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        gerarLink () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-compartilhamento/gerar-link/${this.tipo}/${this.alvoId}`,
                { dias: this.diasLink }, this.auth()).then(r => {
                window.eventBus.$emit('loading', false)
                this.linkGerado = window.location.origin + '/documento-publico/' + r.data.token
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        copiar () {
            const el = document.createElement('textarea')
            el.value = this.linkGerado
            document.body.appendChild(el)
            el.select()
            try { document.execCommand('copy') } catch (e) { /* navegador antigo */ }
            document.body.removeChild(el)
            window.eventBus.$emit('alert', { msg: 'Link copiado.', type: 'success' })
        },

        definirVisibilidade (v) {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/documento-compartilhamento/visibilidade/${this.alvoId}`,
                { publico: v }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', {
                    msg: v ? 'Documento agora é público.' : 'Documento agora é privado.', type: 'success'
                })
                this.$emit('atualizado')
            }).catch(e => { this.publicoLocal = !v; this.erro(e) })
        }
    }
}
</script>
<style scoped>
.meta { font-size: 12px; color: #909399; }
.link-gerado { background: #F5F7FA; padding: 8px; border-radius: 4px; }
</style>
